import { inject } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { environment } from "../../../environments/environment";
import { AuthService } from "../services/auth/auth.service";

export const onboardedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // If onboarding is disabled in environment, always allow access
  if (!environment.ENABLE_ONBOARDING) {
    return true;
  }

  if (auth.onboarded) {
    return true;
  } else if (!auth.authenticated) {
    router.navigate(["signin"]);
    return false;
  } else {
    router.navigate(["onboarding"]);
    return false;
  }
};
